import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ngfModule } from 'angular-file';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { WorkWidgetHeaderModule } from 'shared/components/work-widget-header/work-widget-header.module';
import { AutoSaveModule } from '../../../../../common/auto-save/auto-save.module';
import { EmailOutgoingHeaderModule } from '../../../../../shared/components/email-outgoing-header/email-outgoing-header.module';
import { AlertBoxModule } from '../../../../../shared/components/alert-box/alert-box.module';
import { InactiveWidgetFooterModule } from '../shared/components/inactive-widget-footer/inactive-widget-footer.module';
import { TinyMCEEditorModule } from '../../../../../shared/components/editor/editor.module';
import { EmailAttachmentsModule } from '../../../../../shared/components/email-attachments/email-attachments.module';
import { CannedMessageModule } from '../../../../../shared/components/canned-message-panel/canned-message-panel.module';
import { EmailComposeComponent } from './email-compose.component';
import { TranslateModule } from '@ngx-translate/core';
import { WorkWidgetControlPanelModule } from '../../../../../shared/components/work-widget-control-panel/work-widget-control-panel.module';
import { EmailAccountsService } from '../shared/services/email-accounts.service';

@NgModule({
  imports: [
    CommonModule,
    ngfModule,
    SvgIconModule,
    WorkWidgetHeaderModule,
    AutoSaveModule,
    EmailOutgoingHeaderModule,
    AlertBoxModule,
    InactiveWidgetFooterModule,
    TinyMCEEditorModule,
    EmailAttachmentsModule,
    CannedMessageModule,
    TranslateModule.forRoot(),
    WorkWidgetControlPanelModule
  ],
  providers: [
    EmailAccountsService
  ],
  declarations: [
    EmailComposeComponent
  ],
  exports: [
    EmailComposeComponent
  ]
})

export class EmailComposeModule {}
